import storeFactory from '@/helpers/storeFactory'

const createModel = () => ({
  event_uuid: null,
  places: null,
  train_number: null,
  type: null,
  from: '',
  to: '',
  arrival: new Date(),
  departure: new Date(),
  departure_date: new Date(),
  deviation_type: 'CANCELED_STOP'
})
export default storeFactory({
  model: createModel(),

  state: {
    pending: {
      searchTrain: false
    }
  },

  mutations: {
    resetModel(state) {
      state.model = createModel()
    }
  },
  getters: {
    newItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const delays = trafficMessageModel.delays
      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )
      return checkedItems.filter(x => !delays.includes(x.uuid)).length
    },

    missingItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const delays = trafficMessageModel.delays
      const missingItems =
        delays?.filter(uuid => state.data[uuid] && !state.data[uuid].checked) ||
        []
      return missingItems.length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
